import { useCreateEntity } from '@abaninja/util-store';

import { pay } from '../documents';

export const useDocumentPayStore = () => useCreateEntity(pay);
